import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { expenseCategoryLabel } from '../constants/expense-category.map';
import { ExpenseCategory } from '../enums/expense-category.enum';

/**
 * Categoría → texto a mostrar.
 *
 * Traduce los slugs conocidos y devuelve el valor literal para los que no lo
 * son (categorías nuevas de la app o los códigos numéricos del histórico), de
 * modo que nunca se pierde información en pantalla.
 *
 * Impuro con memo interno para reaccionar al cambio de idioma sin obligar a cada
 * plantilla a pasar el locale; el coste por celda es un lookup en un Map.
 */
@Pipe({ name: 'expenseCategoryLabel', pure: false })
export class ExpenseCategoryLabelPipe implements PipeTransform {
  private readonly cache = new Map<string, string>();

  constructor(private readonly translate: TranslateService) {}

  transform(category: ExpenseCategory | null | undefined): string {
    const language = this.translate.currentLang || this.translate.defaultLang;
    const cacheKey = `${category ?? ''}|${language}`;

    const cached = this.cache.get(cacheKey);
    if (cached !== undefined) {
      return cached;
    }

    const label = expenseCategoryLabel(category);
    const text =
      label.kind === 'translate'
        ? this.translate.instant(label.value)
        : label.value;

    this.cache.set(cacheKey, text);

    return text;
  }
}
